// Display labels for entity_audit_log field names.
// Kept in sync with api/src/services/entityAudit.js - unknown fields fall
// back to the raw field name in the UI, so a missing entry is cosmetic only.

export const CUSTOMER_AUDIT_FIELD_LABELS = {
  business_name: 'Business Name',
  legal_name: 'Legal Name',
  customer_type: 'Customer Type',
  status: 'Status',
  tier: 'Tier',
  tags: 'Tags',
  address_line_1: 'Address Line 1',
  address_line_2: 'Address Line 2',
  town_city: 'Town/City',
  county_region: 'County/Region',
  state_province: 'State / Province',
  postcode: 'Postcode/Zipcode',
  country_code: 'Country',
  timezone: 'Timezone',
  location_description: 'Location Description',
  territory: 'Territory',
  currency: 'Currency',
  payment_terms: 'Payment Terms',
  vat_number: 'VAT Number',
  tax_id: 'Tax ID',
  account_owner_id: 'Account Owner',
  source: 'Heard about us',
  source_other: 'Heard about us (detail)',
  referred_by_id: 'Referred By',
  sale_channel: 'Sale Channel',
  commercial_owner: 'Commercial Owner',
  master_distributor_id: 'Master Distributor',
  sub_distributor_id: 'Sub Distributor',
  install_distributor_id: 'Install Distributor',
  distributor_level: 'Distributor Level',
  parent_distributor_id: 'Parent Distributor',
  regions_covered: 'Regions Covered',
  partner_since: 'Partner Since',
  contract_renewal_date: 'Contract Renewal Date',
  brush_supply_channel: 'Brush Supply Channel',
  brush_purchase_cadence: 'Brush Purchase Cadence',
  brush_unit_price_minor_units: 'Brush Unit Price',
  brush_last_ship_date: 'Brush Last Ship Date',
  brush_distributor_id: 'Brush Distributor',
  brush_distributor_price_minor_units: 'Brush Distributor Price',
  brush_ordering_agreement: 'Brush Ordering Agreement',
  primary_contact_id: 'Primary Contact',
  technical_contact_id: 'Technical Contact',
  service_contract_type: 'Service Contract Type',
  contract_start_date: 'Contract Start Date',
  service_contract_renewal_date: 'Service Contract Renewal',
  sla_response_hrs: 'SLA Response (hrs)',
  sla_resolution_hrs: 'SLA Resolution (hrs)',
  health_score: 'Health Score',
  churn_risk: 'Churn Risk',
  do_not_contact: 'Do Not Contact',
  next_review_date: 'Next Review Date',
  notes: 'Notes',
  lat: 'Latitude',
  lng: 'Longitude',
  travel_time_from_base_mins: 'Travel Time From Base (mins)',
  travel_time_override_mins: 'Travel Time Override (mins)',
  travel_time_override_note: 'Travel Time Override Note',
  logo_url: 'Logo'
};

export const OPPORTUNITY_AUDIT_FIELD_LABELS = {
  customer_id: 'Customer',
  title: 'Title',
  product: 'Product',
  sale_channel: 'Sale Channel',
  opportunity_type: 'Opportunity Type',
  stage: 'Stage',
  value_minor_units: 'Value',
  currency: 'Currency',
  expected_close: 'Expected Close',
  probability_pct: 'Probability %',
  distributor_id: 'Distributor',
  sub_distributor_id: 'Sub Distributor',
  install_distributor_id: 'Install Distributor',
  end_customer_id: 'End Customer',
  primary_contact_id: 'Primary Contact',
  owner_id: 'Owner',
  territory: 'Territory',
  source: 'Heard about us',
  lost_reason: 'Lost Reason',
  competitor: 'Competitor',
  ptl_intervention_required: 'PTL Intervention Required',
  ptl_intervention_note: 'PTL Intervention Note',
  is_monitored: 'On Watchlist',
  monitor_reason: 'Watchlist Reason',
  monitor_priority: 'RAG Priority',
  monitor_review_date: 'Watchlist Review Date',
  monitor_assigned_to_id: 'Watchlist Assignee',
  install_fee_minor_units: 'Install Fee',
  monthly_invoicing_active: 'Monthly Invoicing Active',
  monthly_invoice_amount_minor_units: 'Monthly Invoice Amount',
  monthly_invoice_currency: 'Monthly Invoice Currency',
  pricing_summary: 'Pricing Summary',
  pricing_schedule: 'Pricing Schedule',
  notes: 'Notes',
  hardware_components: 'Hardware Components'
};

export const ENGINEER_AUDIT_FIELD_LABELS = {
  full_name: 'Full Name',
  preferred_name: 'Preferred Name',
  email: 'Email',
  employee_number: 'Employee Number',
  role: 'Role',
  is_active: 'Active Account',
  mobile: 'Mobile',
  whatsapp: 'WhatsApp',
  personal_email: 'Personal Email',
  home_address: 'Home Address',
  home_postcode: 'Home Postcode',
  home_lat: 'Home Latitude',
  home_lng: 'Home Longitude',
  primary_region: 'Primary Region',
  can_cover_regions: 'Can Cover Regions',
  group_memberships: 'Group Memberships',
  contract_type: 'Contract Type',
  contracted_hours_per_week: 'Contracted Hours/Week',
  start_date: 'Start Date',
  standard_start_time: 'Standard Start Time',
  standard_end_time: 'Standard End Time',
  working_days: 'Working Days',
  engineer_initials: 'Initials',
  can_assign_work: 'Can Be Assigned Work',
  on_call_eligible: 'On-Call Eligible',
  notification_preferences: 'Notification Preferences'
};
